import React, { ReactElement, useEffect } from 'react';
import { LoaderButton } from 'idsk-react-components';
import { useClient, useClientStatusContext } from '../../../../../../context/ClientStatusContext';
import { useSuccessMessageContext } from '../../../../../../context/SuccessMessageContext';
import uuid from '../../../../../../model/Uuid';
import {
  addSledovatel,
} from '../../../../../../client/external/evidencnaaplikacia/legislativnyMaterialSledovatelClient';
import iconSledovat from '../../../../../../../assets/images/icon-sledovat.svg';

interface Props {
  materialUuid: uuid;
  updateMaterial: () => void;
}

export default function SledovatelAddButton({
  materialUuid,
  updateMaterial,
}: Props): ReactElement {
  const { handleStatus } = useClientStatusContext();
  const { displaySuccess } = useSuccessMessageContext();
  const {
    wrapClient: addSledovatelClient,
    status: addSledovatelStatus,
  } = useClient(addSledovatel);

  function successAndScroll(message: string): void {
    displaySuccess(message);
    document.querySelector('.success-message')?.scrollIntoView({ behavior: 'smooth' });
  }

  const addSledovatelToMaterial = async (): Promise<void> => {
    await addSledovatelClient(materialUuid);
    updateMaterial();
    successAndScroll('Proces bol pridaný do zoznamu sledovaných procesov.');
  };

  useEffect(() => {
    if (addSledovatelStatus.responseCode === 404) {
      addSledovatelStatus.responseCode = 500;
      handleStatus(addSledovatelStatus);
    }
  }, [addSledovatelStatus, handleStatus]);

  return (
    <LoaderButton
      buttonStyle="third"
      className="action__button"
      size="large"
      customIconBefore={iconSledovat}
      onClick={addSledovatelToMaterial}
      loading={addSledovatelStatus.loading}
      disableOutsideClickWhileLoading
    >Sledovať proces
    </LoaderButton>
  );
}
